import { smallScreen } from 'common/theme'
import { StyledVehicleAuctionInfo } from 'modules/BuyerActivity/VehicleAuction.styled'
import { Button } from 'react-bootstrap'
import styled from 'styled-components'

export const StyleVehicleDataCard = styled(StyledVehicleAuctionInfo).attrs({
  className: 'card h-100'
})`
  margin-bottom: 0rem;
  margin-top: 0rem;
  .dashboard-reserver-bid {
    button {
      @media (min-width: ${smallScreen}) {
        width: 10rem;
        height: 3.5rem;
      }
    }
  }
`

export const StyledPrice = styled.div`
  font-size: 1.6rem;
  font-weight: bold;
`
export const StyledPurchaseButton = styled(Button)`
  min-width: 12rem;
  margin: 0.5rem 0.5rem;
  font-size: 1.1rem;
`
export const StyledNotInterestedButton = styled(Button).attrs({
  className: 'btn-secondary'
})`
  min-width: 12rem;
  margin: 0.5rem 0.5rem;
  font-size: 1.1rem;
`
